export const RACE_FEATURES = {
    'Human': [
        { name: 'Resourceful', level: 1, type: 'Race Feature', desc: 'You gain Heroic Inspiration daily.' },
        { name: 'Skillful', level: 1, type: 'Race Feature', desc: 'You gain proficiency in one Skill of your choice.', interactive: 'skill', count: 1 },
        { name: 'Versatile', level: 1, type: 'Race Feature', desc: 'You gain one Origin Feat of your choice.', interactive: 'originFeat' } // Removed extra language as per 2024? Or keeping? 2024 usually just Common + 1
    ],
    'Elf': [
        { name: 'Darkvision', level: 1, type: 'Race Feature', desc: '60ft dim light as bright, darkness as dim.' },
        { name: 'Keen Senses', level: 1, type: 'Race Feature', desc: 'Proficiency in Insight, Perception, or Survival.', interactive: 'skill', options: ['Insight', 'Perception', 'Survival'] },
        { name: 'Fey Ancestry', level: 1, type: 'Race Feature', desc: 'Advantage to end Charm, Trance (4hr long rest).' },
        { name: 'Lineage', level: 1, type: 'Race Feature', desc: 'Choose a lineage that describes your elven heritage.', interactive: 'lineage' }
    ],
    'High Elf': [
        { name: 'High Elf Lineage', level: 1, type: 'Race Feature', desc: 'Wizard Cantrip, Detect Magic prepared.' },
        { name: 'Cantrip', level: 1, type: 'Race Feature', desc: 'Choose a Wizard Cantrip.', interactive: 'cantrip' },
        { name: 'Detect Magic', level: 1, type: 'Spell', desc: 'You can cast Detect Magic without a slot once per Long Rest.' },
        { name: 'Misty Step', level: 3, type: 'Spell', desc: 'You can cast Misty Step without a slot once per Long Rest.' }
    ],
    'Wood Elf': [
        { name: 'Wood Elf Lineage', level: 1, type: 'Race Feature', desc: 'Speed 35ft, Druidcraft, Longstrider, Pass Without Trace.' },
        { name: 'Druidcraft', level: 1, type: 'Spell', desc: 'You know the Druidcraft cantrip.' },
        { name: 'Longstrider', level: 1, type: 'Spell', desc: 'You can cast Longstrider without a slot once per Long Rest.' },
        { name: 'Pass Without Trace', level: 3, type: 'Spell', desc: 'You can cast Pass Without Trace without a slot once per Long Rest.' }
    ],
    'Drow': [
        { name: 'Drow Lineage', level: 1, type: 'Race Feature', desc: 'Darkvision 120ft, Dancing Lights, Faerie Fire, Darkness. Charisma +1.' },
        { name: 'Superior Darkvision', level: 1, type: 'Race Feature', desc: '120ft dim light as bright, darkness as dim.' },
        { name: 'Dancing Lights', level: 1, type: 'Spell', desc: 'Know Dancing Lights cantrip.' },
        { name: 'Faerie Fire', level: 3, type: 'Spell', desc: '1/LR.' },
        { name: 'Darkness', level: 5, type: 'Spell', desc: '1/LR.' }
    ],
    'Tiefling': [
        { name: 'Darkvision', level: 1, type: 'Race Feature', desc: '60ft dim light as bright, darkness as dim.' },
        { name: 'Otherworldly Presence', level: 1, type: 'Race Feature', desc: 'Know Thaumaturgy cantrip.' },
        { name: 'Lineage', level: 1, type: 'Race Feature', desc: 'Choose Abyssal, Chthonic, or Infernal.', interactive: 'lineage' }
    ],
    'Abyssal': [
        { name: 'Abyssal Lineage', level: 1, type: 'Race Feature', desc: 'Poison Res., Poison Spray (Lv1), Ray of Sickness (Lv3), Hold Person (Lv5).' },
        { name: 'Poison Spray', level: 1, type: 'Spell', desc: 'Know cantrip.' },
        { name: 'Ray of Sickness', level: 3, type: 'Spell', desc: '1/LR.' },
        { name: 'Hold Person', level: 5, type: 'Spell', desc: '1/LR.' }
    ],
    'Chthonic': [
        { name: 'Chthonic Lineage', level: 1, type: 'Race Feature', desc: 'Necrotic Res., Chill Touch (Lv1), False Life (Lv3), Ray of Enfeeblement (Lv5).' },
        { name: 'Chill Touch', level: 1, type: 'Spell', desc: 'Know cantrip.' },
        { name: 'False Life', level: 3, type: 'Spell', desc: '1/LR.' },
        { name: 'Ray of Enfeeblement', level: 5, type: 'Spell', desc: '1/LR.' }
    ],
    'Infernal Legacy': [
        { name: 'Infernal Lineage', level: 1, type: 'Race Feature', desc: 'Fire Res., Fire Bolt (Lv1), Hellish Rebuke (Lv3), Darkness (Lv5).' },
        { name: 'Fire Bolt', level: 1, type: 'Spell', desc: 'Know cantrip.' },
        { name: 'Hellish Rebuke', level: 3, type: 'Spell', desc: '1/LR.' },
        { name: 'Darkness', level: 5, type: 'Spell', desc: '1/LR.' }
    ],
    'Dragonborn': [
        { name: 'Draconic Ancestry', level: 1, type: 'Race Feature', desc: 'Choose a dragon type for Breath Weapon and Resistance.', interactive: 'lineage' },
        { name: 'Breath Weapon', level: 1, type: 'Action', desc: 'Replace attack with 15ft Cone or 30ft Line (d10 dmg). Save vs Dmg.' },
        { name: 'Damage Resistance', level: 1, type: 'Race Feature', desc: 'Resistance to your ancestry damage type.' },
        { name: 'Darkvision', level: 1, type: 'Race Feature', desc: '60ft dim light as bright.' },
        { name: 'Draconic Flight', level: 5, type: 'Action', desc: 'Spectral wings give Fly Speed 10 min (1/LR).' }
    ],
    'Gnome': [
        { name: 'Darkvision', level: 1, type: 'Race Feature', desc: '60ft dim light as bright.' },
        { name: 'Gnomish Cunning', level: 1, type: 'Race Feature', desc: 'Advantage on Int/Wis/Cha saves vs magic.' },
        { name: 'Gnomish Lineage', level: 1, type: 'Race Feature', desc: 'Choose Forest or Rock Gnome.', interactive: 'lineage' }
    ],
    'Forest Gnome': [
        { name: 'Forest Gnome Lineage', level: 1, type: 'Race Feature', desc: 'Know Minor Illusion, Speak with Small Beasts.' },
        { name: 'Minor Illusion', level: 1, type: 'Spell', desc: 'Know cantrip.' },
        { name: 'Speak with Small Beasts', level: 1, type: 'Race Feature', desc: 'Communicate with small animals.' }
    ],
    'Rock Gnome': [
        { name: 'Rock Gnome Lineage', level: 1, type: 'Race Feature', desc: 'Know Mending, Prestidigitation. Tinker.' },
        { name: 'Mending', level: 1, type: 'Spell', desc: 'Know cantrip.' },
        { name: 'Prestidigitation', level: 1, type: 'Spell', desc: 'Know cantrip.' }
    ],
    'Goliath': [
        { name: 'Giant Ancestry', level: 1, type: 'Race Feature', desc: 'Choose Cloud, Fire, Frost, Hill, Stone, or Storm.', interactive: 'lineage' },
        { name: 'Large Form', level: 5, type: 'Bonus Action', desc: 'Become Large size (Adv STR, +10 Speed). 10 min, 1/LR.' },
        { name: 'Powerful Build', level: 1, type: 'Race Feature', desc: 'Adv to end Grappled. Count as Large for carrying.' },
        { name: 'Speed', level: 1, type: 'Race Feature', desc: 'Speed is 35 ft.' }
    ],
    'Halfling': [
        { name: 'Lucky', level: 1, type: 'Race Feature', desc: 'Reroll 1s on d20.' },
        { name: 'Brave', level: 1, type: 'Race Feature', desc: 'Advantage on saves vs Frightened.' },
        { name: 'Halfling Nimbleness', level: 1, type: 'Race Feature', desc: 'Move through space of larger creatures.' },
        { name: 'Naturally Stealthy', level: 1, type: 'Race Feature', desc: 'Hide even when obscured only by larger creature.' }
    ],
    'Orc': [
        { name: 'Darkvision', level: 1, type: 'Race Feature', desc: '120ft dim light as bright.' },
        { name: 'Adrenaline Rush', level: 1, type: 'Bonus Action', desc: 'Dash and gain THP.' },
        { name: 'Relentless Endurance', level: 1, type: 'Race Feature', desc: 'Drop to 1 HP once per long rest.' }
    ],
    'Dwarf': [
        { name: "Darkvision", level: 1, type: 'Race Feature', desc: "120ft range." },
        { name: "Dwarven Resilience", level: 1, type: 'Race Feature', desc: "Resistance to Poison damage. Adv on Poisoned saves." },
        { name: "Dwarven Toughness", level: 1, type: 'Race Feature', desc: "+1 HP per level." },
        { name: "Stonecunning", level: 1, type: 'Bonus Action', desc: "Tremorsense 60ft on stone (10 min, PB/LR)." }
    ],
    'Aasimar': [
        { name: "Celestial Resistance", level: 1, type: 'Race Feature', desc: "Resistance to Necrotic and Radiant damage." },
        { name: "Darkvision", level: 1, type: 'Race Feature', desc: "60ft range." },
        { name: "Healing Hands", level: 1, type: 'Action', desc: "Heal target for d4s equal to PB (1/LR)." },
        { name: "Light Bearer", level: 1, type: 'Race Feature', desc: "You know the Light cantrip." },
        { name: "Celestial Revelation", level: 3, type: 'Bonus Action', desc: "Transform for flight or damage." } // Level 3 choice usually? Or just one form per 2024?
    ]
};
